import React, { useEffect, useState } from "react";
import { project, projectGroup } from "../../../system/types/project/project";
import { initialProject } from "../../../system/initial/project";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";
import Icon from "@mdi/react";
import { mdiChevronDown, mdiChevronRight, mdiFolderEditOutline, mdiFolderPlusOutline, mdiNotePlusOutline } from "@mdi/js";
import { dispatch } from "../../../App";
import { actions } from "../../../redux";
import { ListTranslations } from "./ListTranslations";


interface props {
    parentId: string;
}

const ProjectGroups = (props: props) => {

    const [projectData, setProjectData] = useState<project>(initialProject);

    const [listGroups, setListGroups] = useState<projectGroup[]>([]);

    const [selectedGroup, setSelectedGroup] = useState<string>('');


    useSelector((state: RootState) => {
        if (state.project.projectData !== projectData) {
            setProjectData(state.project.projectData);
        }
    });

    const addGroup = () => {
        dispatch(actions.project.setPageCommand('editGroup'));
        dispatch(actions.project.setPageCommandId(''));
    };

    const editGroup = (groupId: string) => {
        dispatch(actions.project.setPageCommand('editGroup'));
        dispatch(actions.project.setPageCommandId(groupId));
    }

    const addTranslation = (groupId: string) => {
        dispatch(actions.project.setPageCommand('editTranslation'));
        dispatch(actions.project.setPageCommandId(''));
        dispatch(actions.project.setPageCommandSubSelect(groupId));
        setSelectedGroup(groupId);
    }

    const toggleGroupSelect = (groupId: string) => {
        if (selectedGroup === groupId) {
            setSelectedGroup('');
            return;
        }
        setSelectedGroup(groupId);
    };

    useEffect(() => {
        setListGroups(projectData.groups);
    }, [projectData])

    //mdiFolderEditOutline

    return (<>
        <div className="row mb-3">
            <div className="col-7"></div>
            <div className="col-auto"><button onClick={addGroup} className="btn btn-outline-primary"><Icon path={mdiFolderPlusOutline} size={1} /></button></div>
        </div>
        {listGroups.map((group) => (
            <span key={group.uniqueId}>
                <div className="row mb-3">
                    <div className="col-1"><button onClick={() => {
                        toggleGroupSelect(group.uniqueId);
                    }} className="btn btn-outline-primary">{
                            selectedGroup === group.uniqueId ?
                                <Icon path={mdiChevronDown} size={1} />
                                :
                                <Icon path={mdiChevronRight} size={1} />
                        }</button></div>
                    <div className="col-6">{group.name} - ({group.key})<br />{group.description}</div>
                    <div className="col-auto"><button onClick={() => {
                        editGroup(group.uniqueId);
                    }} className="btn btn-outline-primary"><Icon path={mdiFolderEditOutline} size={1} /></button></div>
                    <div className="col-auto"><button onClick={() => {
                        addTranslation(group.uniqueId);
                    }} className="btn btn-outline-primary"><Icon path={mdiNotePlusOutline} size={1} /></button></div>
                </div>
                {selectedGroup === group.uniqueId ? <ListTranslations groupId={group.uniqueId}></ListTranslations> : null}
            </span>
        ))}
    </>);
}

export { ProjectGroups };
